import React, { useEffect, useState } from "react";
import Slider from "react-slick";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
import PromoCard from "./PromoCard";
import "./promo-carousel.scss";
import { get } from "../../../utils/request";
import { Constants } from "../../../constants/Contants";

const PromoCarousel = () => {
  const [promos, setPromos] = useState([]);
  const [selectedPromo, setSelectedPromo] = useState(null);

  useEffect(() => {
    const fetchPromos = async () => {
      try {
        const recommendPromos = await get(Constants.getRecommendPromos);
        setPromos(Array.isArray(recommendPromos) ? recommendPromos : []);
      } catch (error) {
        console.error("Error fetching promos:", error);
        setPromos([]);
      }
    };
    fetchPromos();
  }, []);

  const settings = {
    dots: true,
    infinite: true,
    autoplay: true,
    autoplaySpeed: 4000,
    slidesToShow: 3,
    slidesToScroll: 1,
    responsive: [
      {
        breakpoint: 1024,
        settings: { slidesToShow: 2 },
      },
      {
        breakpoint: 768,
        settings: { slidesToShow: 1 },
      },
    ],
  };

  if (!promos.length) {
    return null;
  }

  return (
    <>
      <section className="unlock-savings teleport-section" aria-labelledby="unlock-savings-title">
        <div className="unlock-savings__intro">
          <p className="teleport-eyebrow">Service-specific offers</p>
          <h2 id="unlock-savings-title">Unlock savings</h2>
          <p>Explore current Teleport offers. Eligibility and live pricing are confirmed within the relevant service checkout.</p>
        </div>
        <div className="promo-section">
          <div className="promo-container">
            <div className="promo-heading">
              <div>
                <p className="promo-eyebrow">App-only offers</p>
                <h2 className="promo-title">Current Promos</h2>
              </div>
            </div>
            <div className="promo-slider">
              <Slider {...settings}>
                {promos?.map((promo) => (
                  <div
                    key={promo._id}
                    onClick={() => {
                      if (typeof window !== "undefined" && typeof window.gtag === "function") {
                        window.gtag("event", "promo_click", {
                          promo_name: promo.promo_name,
                        });
                      }
                      setSelectedPromo(promo);
                    }}
                  >
                    <PromoCard promo={promo} />
                  </div>
                ))}
              </Slider>
            </div>
          </div>
        </div>
      </section>

      {/* === Promo Modal === */}
      {selectedPromo && (
        <div
          className="promo-modal-overlay"
          onClick={() => setSelectedPromo(null)}
        >
          <div className="promo-modal" onClick={(e) => e.stopPropagation()}>
            <button
              className="close-btn"
              onClick={() => setSelectedPromo(null)}
            >
              ×
            </button>

            {selectedPromo.banner_url ? (
              <img
                src={selectedPromo.banner_url}
                alt={selectedPromo.promo_name}
                className="promo-modal-banner"
              />
            ) : (
              <div className="no-banner">No Image</div>
            )}

            <div className="promo-modal-content">
              <h2 className="promo-modal-title">{selectedPromo.promo_name}</h2>
              <p className="promo-desc">
                {selectedPromo.description || "No description provided."}
              </p>

              <div className="promo-details">
                <p>
                  <strong>Discount:</strong>{" "}
                  {selectedPromo.type === "label"
                    ? selectedPromo.discount_value
                    : selectedPromo.type === "amount"
                    ? `${selectedPromo.currency} $${selectedPromo.discount_value}`
                    : `${selectedPromo.discount_value}%`}
                </p>
                {selectedPromo.capped_amount && (
                  <p>
                    <strong>Capped at:</strong> {selectedPromo.currency} $
                    {selectedPromo.capped_amount}
                  </p>
                )}
                <p>
                  <strong>Promo Code:</strong>{" "}
                  <span className="highlight">{selectedPromo.code}</span>
                </p>
                <p>
                  <strong>Start Date:</strong> {selectedPromo.start_datetime}
                </p>
                <p>
                  <strong>End Date:</strong> {selectedPromo.end_datetime}
                </p>
              </div>
            </div>
          </div>
        </div>
      )}
    </>
  );
};

export default PromoCarousel;
